// extracted by mini-css-extract-plugin
export default {"personalinfo":"PersonalInfo_personalinfo__vKk3b","button":"PersonalInfo_button__9UgC2","header":"PersonalInfo_header__vos11","label":"PersonalInfo_label__tpqvJ"};